import HTTP from '@/http-common.js'

const FetchFeed = {
  data() {
    // Get API keys from current user org or, if possible, get api key for current post from $route query
    let apiKeys = this.$store.state.accounts.api_keys
    if (this.$store.state.websites.current) apiKeys = this.$store.state.websites.current
    let orgID = null
    if (this.$store.state.accounts.user.is_admin === false) orgID = this.$store.state.accounts.user.org_id

    return {
      items: {
        counts: {},
        resources: [],
      },
      searchParams: {
        tags: {},
        types: [],
        search_query: '',
        offset: 0,
        limit: 10,
        order_by: 'updated',
        order_dir: 'desc',
        lang: 'en',
        status: ['published', 'draft', 'flagged', 'disabled', 'unlisted'],
        start_datetime: null,
        end_datetime: null,
        frontend_submissions: false,
        api_keys: apiKeys,
        org_id: orgID,
        show_children: true,
        only_root_pages: true,
        is_backend: true,
      },
      errors: [],
      loading: true,
    }
  },
  methods: {
    fetchFeed(params) {
      this.loading = true
      params = { ...this.searchParams, ...params }

      HTTP.post('search/resource', params)
        .then((response) => {
          // Fetch items

          this.items = response.data

          // Set default language
          // this.lang = params.lang

          this.loading = false
        })
        .catch((e) => {
          this.errors = e.response ? e.response.data : console.error(e)
          this.loading = false
        })
    },
  },
}

export default FetchFeed
